import * as React from "react"
import { forwardRef } from "react"
import "./scrollable-area.css"
import classNames from "classnames"

type ScrollableAreaProps = {
    className?: string
    shouldPreventScrollbarShifting?: boolean
    horizontal?: boolean
} & React.PropsWithChildren

export const ScrollableArea = forwardRef<
    HTMLDivElement,
    ScrollableAreaProps & React.HTMLAttributes<HTMLDivElement>
>(({ className, shouldPreventScrollbarShifting, horizontal, children, ...rest }, ref) => {
    return (
        <div
            className={classNames("scrollable-area", { horizontal }, className)}
            ref={ref}
            {...rest}
            style={{
                scrollbarGutter: shouldPreventScrollbarShifting ? "stable" : undefined,
                ...rest.style,
            }}
        >
            {shouldPreventScrollbarShifting ? (
                <div className="-mr-[5px] h-full">{children}</div>
            ) : (
                children
            )}
        </div>
    )
})

export const hasScrollbar = (element: HTMLElement) => {
    return {
        vertical: element.scrollHeight > element.clientHeight,
        horizontal: element.scrollWidth > element.clientWidth,
    }
}
